import { Box, Card, Skeleton } from '@factorialco/deprecated-design-system'

const SkeletonLoaderCard = () => {
  return (
    <Card>
      <Card.Content>
        <Box width="full" flexDirection="row" flexGrow>
          <Box inline flexDirection="column" justifyContent="flexStart" width="full" gap="s40">
            <Skeleton width="s140" height="s24" isLoading />
            <Box flexDirection="row" gap="s8">
              <Skeleton width="s200" height="s40" isLoading />
              <Skeleton width="s200" height="s40" isLoading />
              <Skeleton width="s200" height="s40" isLoading />
            </Box>
            <Box flexDirection="row" gap="s8">
              <Skeleton width="s32" height="s32" isLoading />
            </Box>
          </Box>
        </Box>
      </Card.Content>
    </Card>
  )
}

export default SkeletonLoaderCard
